import React from 'react';
type SectionHeadingProps = {
  title: string;
  text?: string;
  eyebrow?: string;
  as?: 'h1' | 'h2';
  align?: 'center' | 'left';
};
export function SectionHeading({
  title,
  text,
  eyebrow,
  as = 'h2',
  align = 'center'
}: SectionHeadingProps) {
  const Tag = as;
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-270" data-mp="3k06y7yjxd00d">
      {eyebrow && <span className="tis-eyebrow" data-id="element-271" data-mp="bkdihlxf3skd">{eyebrow}</span>}
      <Tag className="font-slab text-[clamp(2.2rem,3.6vw,6rem)] font-black uppercase leading-[0.9] tracking-[0.01em]" data-id="element-272" data-mp="bkvld1el5519">{title}</Tag>
      {text && <p className="mt-5 text-[clamp(1rem,.5vw+.75rem,1.45rem)] leading-relaxed text-ink-muted" data-id="element-273" data-mp="1uk287mbyp9s">{text}</p>}
    </div>;
}